import { render, staticRenderFns } from "./OpcionNoAceptada.vue?vue&type=template&id=73997350&scoped=true"
import script from "./OpcionNoAceptada.vue?vue&type=script&lang=js"
export * from "./OpcionNoAceptada.vue?vue&type=script&lang=js"
import style0 from "./OpcionNoAceptada.vue?vue&type=style&index=0&id=73997350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73997350",
  null
  
)

export default component.exports